import React from 'react';
import $ from 'jquery';
import _ from 'lodash';

import 'react-select/scss/default.scss';
import './GeneralSettingsModal.scss';
import axios from '../../lib/AxiosInstance';
import WistiaUploader from '../WistiaUploader/WistiaUploader';
import reducerStore from '../../reducers/reducerStore';
import Toggle from '../Toggle/Toggle';

class globalSettings extends React.Component {

    constructor(props) {
        super(props);

        this.profileColors = this.profileColors.bind(this);
        this.setSlideInterval = this.setSlideInterval.bind(this);
        this.setNotificationThreshold = this.setNotificationThreshold.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    profileColors() {
        const profileState = { useCompanyProfileColors: !this.props.useCompanyProfile };

        Promise.all([
            axios.put('/api/salestv/companyProfile', profileState),
            axios.get('/api/companyProfile'),
        ]).then(([res, companyProfile]) => {
            let profile;
            if (profileState.useCompanyProfileColors) {
                profile = {
                    colors: companyProfile.data.colors,
                    extraColors: companyProfile.data.extraColors,
                    logo: companyProfile.data.logo,
                };  
            } else {
                profile = {
                    colors: { mainBg: '#002f65' },
                    extraColors: null,
                    logo: null,
                };
                
            }

            reducerStore.dispatch({ type: 'TOGGLE PROFILE COLORS', companyProfile: profile})
        }).catch(error => console.log(error));
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.clientId !== nextProps.clientId || 
            this.props.useCompanyProfile !== nextProps.useCompanyProfile ||
            this.props.slideInterval !== nextProps.slideInterval ||
            this.props.notificationThreshold !== nextProps.notificationThreshold) {
            return true;
        }

        return false;
    }

    setSlideInterval(e) {
        const newCompanyProfileState = { slideInterval: parseInt(e.target.value.replace(/\D/g,'')) };
        if (newCompanyProfileState.slideInterval > 0) {
            axios.put('/api/salestv/companyProfile', newCompanyProfileState)
                .then(() => reducerStore.dispatch({ type: 'UPDATE SLIDE INTERVAL', slideInterval: newCompanyProfileState.slideInterval}))
                .catch(error => console.log(error));
        }
    }

    setNotificationThreshold(e) {
        const newCompanyProfileState = { notificationThreshold: parseInt(e.target.value.replace(/\D/g,'')) };
        if (newCompanyProfileState.notificationThreshold >= 0) {
            axios.put('/api/salestv/companyProfile', newCompanyProfileState)
                .then(() =>reducerStore.dispatch({ type: 'UPDATE NOTIFICATION THRESHOLD', notificationThreshold: newCompanyProfileState.notificationThreshold}))
                .catch(error => console.log(error));
        }
    }

    closeModal() {
        reducerStore.dispatch({ type: 'TOOGLE SETTINGS MODAL' });
    }

    render() {
        const { useCompanyProfile, slideInterval, notificationThreshold, currency } = this.props;

        return (
            <div className="general-settings">
                <div className="overlay" onClick={this.closeModal}>
                    <div className="close-modal-btn">
                        <i className="fa fa-times" aria-hidden="true" />
                    </div>
                    <p>
                        <a href="/api/auth/logout"><i className="fa fa-sign-out" aria-hidden="true" /> Logga ut</a>
                    </p>
                </div>
                <div className="global-settings">
                    <div className="settings-header">
                        <h2>Generella inställningar</h2>
                    </div>
                    <div className="general settings-card">
                        <h2 className="global-setting-heading">Allmänt</h2>
                        <div className="holder">
                            <div className="row">
                                <div className="setting">
                                    <span>Slide timer</span>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            name="slideInterval"
                                            defaultValue={slideInterval}
                                            onBlur={e => this.setSlideInterval(e)}
                                        />
                                        <div className="ig-text">Sekunder</div>
                                    </div>
                                </div>
                                <div className="description">
                                    <span>Bestäm hur länge varje slide ska visas i dina presentationer.</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="setting">
                                    <span>Visa film när beloppet överstiger</span>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            name="notification-threshold"
                                            defaultValue={notificationThreshold}
                                            onBlur={e => this.setNotificationThreshold(e)}
                                        />
                                        <div className="ig-text">{currency}</div>
                                    </div>
                                </div>
                                <div className="description">
                                    <span>Vill ni bara fira större affärer, ange ett minsta belopp här.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="company-profile settings-card">
                        <h2 className="global-setting-heading">Företagsprofil</h2>
                        <div className="row">
                            <div className="setting">
                                <div className="onoffswitch">
                                    <Toggle value={useCompanyProfile} onChange={this.profileColors} className="Toggle-bright-blue" />
                                    <span className="h3-alike">Använd företagsprofilen</span>
                                </div>
                            </div>
                            <div className="description">
                                <p>Aktiverar du företagsprofil så kommer den att plocka färger från dina profilinställningar i Upsales</p>
                            </div>
                        </div>
                    </div>
                    <div className="sale-clips settings-card">
                        <h2 className="global-setting-heading">Säljfilmer</h2>
                        <WistiaUploader clientId={this.props.clientId} />
                    </div>
                </div>
            </div>
        );
    }
}

globalSettings.propTypes = {
    clientId: React.PropTypes.number,
    currency: React.PropTypes.string,
    notificationThreshold: React.PropTypes.number,
    slideInterval: React.PropTypes.number,
    useCompanyProfile: React.PropTypes.bool,
};

export default globalSettings;



/** WEBPACK FOOTER **
 ** ./client/components/GeneralSettingsModal/GeneralSettingsModal.jsx
 **/